


export class KSB1 {
  "companyCode";
  "fiscalYear";
  "period";
  "costCenter";
  "coObjectName";
  "costElement";
  "costElementDescr";
  "name";
  "documentHeaderText";
  "valueInObjCrcy";
  "drCrIndicator";
  "userName";
  "documentDate";
  "documentNumber";
  "purchasingDocument";
  "purchaseOrderText";
  "item";
  "refDocumentNumber";
  "material";
  "partnerCCtr";
  "coPartnerObjectName";
  "fullName";
  "personnelNumber";
  "partnerObject";
  "activityType";
  "valCoAreaCrcy";
  "totalQuantity";
  "createdOn";
  "coAreaCurrency";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `KSB1`.
   */
  static getModelName() {
    return "KSB1";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of KSB1 for dynamic purposes.
  **/
  static factory(data) {
    return new KSB1(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'KSB1',
      plural: 'KSB1s',
      path: 'KSB1s',
      properties: {
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "fiscalYear": {
          name: 'fiscalYear',
          type: 'string'
        },
        "period": {
          name: 'period',
          type: 'string'
        },
        "costCenter": {
          name: 'costCenter',
          type: 'string'
        },
        "coObjectName": {
          name: 'coObjectName',
          type: 'string'
        },
        "costElement": {
          name: 'costElement',
          type: 'string'
        },
        "costElementDescr": {
          name: 'costElementDescr',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "documentHeaderText": {
          name: 'documentHeaderText',
          type: 'string'
        },
        "valueInObjCrcy": {
          name: 'valueInObjCrcy',
          type: 'string'
        },
        "drCrIndicator": {
          name: 'drCrIndicator',
          type: 'string'
        },
        "userName": {
          name: 'userName',
          type: 'string'
        },
        "documentDate": {
          name: 'documentDate',
          type: 'string'
        },
        "documentNumber": {
          name: 'documentNumber',
          type: 'string'
        },
        "purchasingDocument": {
          name: 'purchasingDocument',
          type: 'string'
        },
        "purchaseOrderText": {
          name: 'purchaseOrderText',
          type: 'string'
        },
        "item": {
          name: 'item',
          type: 'string'
        },
        "refDocumentNumber": {
          name: 'refDocumentNumber',
          type: 'string'
        },
        "material": {
          name: 'material',
          type: 'string'
        },
        "partnerCCtr": {
          name: 'partnerCCtr',
          type: 'string'
        },
        "coPartnerObjectName": {
          name: 'coPartnerObjectName',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "personnelNumber": {
          name: 'personnelNumber',
          type: 'string'
        },
        "partnerObject": {
          name: 'partnerObject',
          type: 'string'
        },
        "activityType": {
          name: 'activityType',
          type: 'string'
        },
        "valCoAreaCrcy": {
          name: 'valCoAreaCrcy',
          type: 'string'
        },
        "totalQuantity": {
          name: 'totalQuantity',
          type: 'string'
        },
        "createdOn": {
          name: 'createdOn',
          type: 'string'
        },
        "coAreaCurrency": {
          name: 'coAreaCurrency',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/KSB1.js